import { useSelector } from 'react-redux'
import { useMailboxAllTicketsCount } from 'ducks/searches/hooks'
import { selectMailbox } from 'selectors/mailboxes_base'
import { selectCurrentMailboxId } from 'selectors/mailboxes'

import TestMessage from 'components/TestMessage/Container'
import EmptyState from '../EmptyState'

const EmptyStateWithTestMessage = ({
  is3ColumnView,
  hasConversations,
  hasLoaded,
}) => {
  const mailboxId = useSelector(state => selectCurrentMailboxId(state))
  const mailbox = useSelector(state => selectMailbox(state, mailboxId))
  const allTicketsCount = useMailboxAllTicketsCount(mailboxId)
  const emptyFor3ColumnsView =
    !hasConversations && allTicketsCount > 0 && is3ColumnView
  const emptyFor4ColumnsView = !hasConversations && !is3ColumnView

  if (hasConversations || !hasLoaded) {
    return null
  }

  if (!mailbox || emptyFor3ColumnsView || emptyFor4ColumnsView) {
    return <EmptyState />
  }

  if (allTicketsCount <= 0) {
    return <TestMessage mailboxId={mailboxId} />
  }

  return null
}

export default EmptyStateWithTestMessage
